import { PureAbility } from '@casl/ability';
import produce, { Draft, castDraft } from 'immer';
import { Reducer } from 'redux';
import { MeType } from 'types/me';

import { retrieveMe, updateMe } from './actions';

export type MeState = {
  loading: boolean;
  error: string | undefined;
  item: MeType | undefined;
  ability: PureAbility;
};

const initialAvailability = new PureAbility();

export const initialState: MeState = {
  loading: false,
  error: undefined,
  item: undefined,
  ability: initialAvailability,
};

const reducer = produce(
  (
    draft: Draft<MeState>,
    { type, payload }: { type: string; payload: any },
  ) => {
    switch (type) {
      case retrieveMe.TRIGGER:
      case updateMe.TRIGGER:
        draft.loading = true;
        draft.error = undefined;
        break;

      // SUCCESS
      case retrieveMe.SUCCESS:
        draft.item = payload.user;
        draft.ability = castDraft(payload.ability);
        break;

      // FAILURE
      case retrieveMe.FAILURE:
      case updateMe.FAILURE:
        draft.error = payload;
        break;

      // FULFILL
      case retrieveMe.FULFILL:
      case updateMe.FULFILL:
        draft.loading = false;
        break;
      // no default
    }
  },
  initialState,
) as Reducer<MeState>;

export default reducer;
